module.exports = __webpack_public_path__ + "img/xqv_54312.13ab976.png";